module.exports = __webpack_public_path__ + "static/media/3.225c3721.jpg";